import React from "react";
import { ReactTFC } from "../../utils/fp/missing-ts-parts";

import { css } from "@emotion/react";

import { CSS_COLORS } from "../../styles/styles-css-variables";
import { SwarovskiLink } from "../_shared-components/ui-elements/SwarovskiLink";
import { Spacer } from "../_shared-components/arrangement/Space";
import { PremiumBadge } from "../DealerLocatorComponent/subcomponents/PremiumBadge";
import { GeneralTranslation } from "@swo/storefront";

import { SegmentIconWithLabel } from "../DealerLocatorComponent/subcomponents/segment-icon-with-label";
import { CSS_MQ } from "../../styles/breakpoints";
import { FONTS } from "../../styles/fonts";
import { plainTextMdStyles } from "../../styles/text-styles";
import { DealerPageData, ExtractSwarovskiPageData } from "@swo/storefront";
import { LeftArrowSvg } from "../../assets";

export const DealerDetailsInfo: ReactTFC<{
  dealerDetails: ExtractSwarovskiPageData<DealerPageData>["data"]["dealerDetails"];
  translations: ExtractSwarovskiPageData<DealerPageData>["data"]["translations"];
  generalTranslations: GeneralTranslation;
  dealerLocatorLink: string;
}> = props => {
  return (
    <React.Fragment>
      <div
        css={css`
          margin-bottom: 30px;
        `}
      >
        {/* SeoHeadline is never defined... */}
        {/* {props.dealerDetails.seoHeadline && <span css={seoHeadlineStyles}>{props.dealerDetails.seoHeadline}</span>} */}
        <span css={dealerNameStyles}>{props.dealerDetails.name}</span>
        {props.dealerDetails.segment && (
          <SegmentIconWithLabel
            translations={{
              birdingLabel: props.generalTranslations.birdingLabel.value,
              huntingLabel: props.generalTranslations.huntingLabel.value,
              outdoorLabel: props.generalTranslations.outdoorLabel.value,
            }}
            cropped={true}
            segment={props.dealerDetails.segment}
          />
        )}
      </div>

      <SwarovskiLink link={props.dealerLocatorLink} isInternal={true} styled={"underline"} scrollToTop={true}>
        <LeftArrowSvg
          css={css`
            height: 1.5em;
            width: auto;
            margin-bottom: -0.5em;

            color: ${CSS_COLORS.Green};
          `}
        />{" "}
        {props.translations.goBackToDealerLocatorLabel.value}
      </SwarovskiLink>

      <Spacer size={"lg"} />

      <DealerDetailsDescription
        isPremium={!!props.dealerDetails.isPremium}
        description={props.dealerDetails.description || null}
      />
    </React.Fragment>
  );
};

const DealerDetailsDescription: ReactTFC<{ isPremium: boolean; description: string | null }> = props => {
  return (
    <div>
      <div css={premiumStyles}>{props.isPremium && <PremiumBadge>Premium</PremiumBadge>}</div>

      {props.description && (
        <React.Fragment>
          <hr
            css={css`
              height: 1px;
              width: 20px;
              background-color: black;
              margin-top: 24px;
              margin-bottom: 24px;
              margin-left: 0;
              display: block;
            `}
          />

          <p css={descriptionStyles}>{props.description}</p>
        </React.Fragment>
      )}
    </div>
  );
};

const dealerNameStyles = css`
  font-family: MinervaModern;
  color: ${CSS_COLORS.Green};

  font-size: 24px;
  letter-spacing: 0.4px;
  line-height: 26px;

  ${CSS_MQ.atLeastMd} {
    font-size: 48px;
    letter-spacing: 2.4px;
    line-height: 48px;
  }

  word-break: break-word;

  display: block;
  margin-bottom: 10px;

  text-transform: uppercase;
  word-break: break-word;
`;

const premiumStyles = css`
  margin-bottom: 20px;
  display: inline-block;
`;

const descriptionStyles = css`
  ${FONTS.SwarovskiFutura300};
  ${plainTextMdStyles};
`;
